import { render, staticRenderFns } from "./PS-quality-widget.vue?vue&type=template&id=b1583a60"
import script from "./PS-quality-widget.vue?vue&type=script&lang=js"
export * from "./PS-quality-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports